
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateTicketTypeModel, TicketAssignmentFilterModel, TicketStatus, TicketType, TicketTypeJobTitle, TicketTypeRole, TicketTypeUser, UpdateTicketTypeModel, ViewType } from 'src/app/models/ticketTypeModels'; // Assuming the models exist

@Injectable({
  providedIn: 'root'
})
export class TicketTypesService {
  private apiUrl = `${environment.apiServer.webApiURL}/tickettype`;

  constructor(private http: HttpClient) {}

  
  getAllTicketTypes(includeArchived: boolean = false): Observable<TicketType[]> {
    return this.http.get<TicketType[]>(this.apiUrl, { params: { includeArchived } });
  }

  getTicketTypeById(id: number): Observable<TicketType> {
    return this.http.get<TicketType>(`${this.apiUrl}/${id}`);
  }

  createTicketType(ticketType: CreateTicketTypeModel): Observable<TicketType> {
    return this.http.post<TicketType>(this.apiUrl, ticketType);
  }

  updateTicketType(id: number, ticketType: UpdateTicketTypeModel): Observable<TicketType> {
    return this.http.put<TicketType>(`${this.apiUrl}/${id}`, ticketType);
  }

  deleteTicketType(id: number, archived: boolean): Observable<TicketType> {
    return this.http.delete<TicketType>(`${this.apiUrl}/${id}`, { params: { archived } });
  }

  reorderStatuses(id: number, startIndex: number, newIndex: number): Observable<TicketStatus[]> {
    return this.http.get<TicketStatus[]>(`${this.apiUrl}/ReorderTicketTypeStatuses/?id=${id}&startIndex=${startIndex}&newIndex=${newIndex}`);
  }

  getViewTypes(): Observable<ViewType[]> {
    return this.http.get<ViewType[]>(`${this.apiUrl}/LoadViewTypes`);
  }

  getCampusList(): Observable<ViewType[]> {
    return this.http.get<ViewType[]>(`${this.apiUrl}/loadcampuses`);
  }

  getFieldTypes(): Observable<ViewType[]> {
    return this.http.get<ViewType[]>(`${this.apiUrl}/LoadFieldTypes`);
  }

  filterTicketUserAssignments(filter: TicketAssignmentFilterModel): Observable<TicketTypeUser[]> {
    return this.http.post<TicketTypeUser[]>(`${this.apiUrl}/filterticketuserassignments`, filter);
  }
  
  filterTicketRoleAssignments(filter: TicketAssignmentFilterModel): Observable<TicketTypeRole[]> {
    return this.http.post<TicketTypeRole[]>(`${this.apiUrl}/filterticketroleassignments`, filter);
  }
  
  filterTicketJobTitleAssignments(filter: TicketAssignmentFilterModel): Observable<TicketTypeJobTitle[]> {
    return this.http.post<TicketTypeJobTitle[]>(`${this.apiUrl}/filterticketjobtitleassignments`, filter);
  }

  saveTicketUserAssignments(ticketTypeID: number, users: TicketTypeUser[]): Observable<TicketTypeUser[]> {
    return this.http.post<TicketTypeUser[]>(`${this.apiUrl}/saveticketuserassignments`, users, { params: { ticketTypeID } });
  }
  
  saveTicketRoleAssignments(ticketTypeID: number, roles: TicketTypeRole[]): Observable<TicketTypeRole[]> {
    return this.http.post<TicketTypeRole[]>(`${this.apiUrl}/saveticketroleassignments`, roles, { params: { ticketTypeID } });
  }
  
  saveTicketJobTitleAssignments(ticketTypeID: number, jobTitles: TicketTypeJobTitle[]): Observable<TicketTypeJobTitle[]> {
    return this.http.post<TicketTypeJobTitle[]>(`${this.apiUrl}/saveticketjobtitleassignments`, jobTitles, { params: { ticketTypeID } });
  }
}
